import { faArrowUp } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import TextArea from '../../../individualReport/pages/components/TextArea';
import CircleGraph from '../components/graphs/circleGraph/CircleGraph';
import CompanyStatistics from './CompanyStatistics';

function LiveAnalytics(props) {
  const { t } = useTranslation();
  const limit = props.threshold;
  const [dataActiveFilter, setDataActiveFilter] = useState(t('CS001'));
  const [dataFilterOpen, setDataFilterOpen] = useState(false);

  const toggleDataFilterOpen = () => {
    setDataFilterOpen(!dataFilterOpen);
  };

  const dataFilterSelectHandler = (event) => {
    if (event.target.tagName === 'svg' && event.target.parentElement.title !== dataActiveFilter) {
      setDataActiveFilter(event.target.parentElement.title);
    } else if (event.target.tagName === 'DIV' && event.target.title !== dataActiveFilter) {
      setDataActiveFilter(event.target.title);
    }
    setDataFilterOpen(false);
  };

  let engagement;
  if (props.coData.report_period_array.length > 0 && props.coData.licences_array.length > 0) {
    engagement = Math.round(
      (100 /
        Number(
          props.coData.licences_array[props.coData.report_period_array.indexOf(props.reportPeriod)]
        )) *
        props.scores.completed_assessments
    );
  } else {
    engagement = Math.round((100 / props.coData.licences) * props.scores.completed_assessments);
  }

  return (
    <div className="report-section active analytics">
      <div className="title_with_filters">
        <h2
          className={
            props.scores.completed_assessments < limit ||
            !props.coData.analytics_open ||
            props.coData.analytics_open !== 'yes'
              ? 'main_title no_nav'
              : 'main_title'
          }
        >
          {t('LA001')} - {props.companyName}
        </h2>
        {props.coData.report_period && (
          <h3 className="period_title">
            {props.coData.report_period.length < 3
              ? t('LA002') + props.coData.report_period
              : props.coData.report_period}{' '}
            - {dataActiveFilter}
          </h3>
        )}
        {(props.scores.completed_assessments >= limit ||
          (props.scores.total < limit && props.filtersArr.length > 0)) &&
          props.coData.analytics_open === 'yes' && (
            <CompanyStatistics
              disableFilters={props.disableFilters}
              threshold={props.threshold}
              onOpenModal={props.onOpenModal}
              data={props.scores}
              coData={props.coData}
              reportPeriod={props.reportPeriod}
              getDataForSetPeriod={props.getDataForSetPeriod}
              onFilterChange={props.onFilterChange}
              isLoading={props.isLoading}
              filtersArr={props.filtersArr}
              toggleFilterOpen={props.toggleFilterOpen}
              filterOpen={props.filterOpen}
              dataFilterSelectHandler={dataFilterSelectHandler}
              dataActiveFilter={dataActiveFilter}
              dataFilterOpen={dataFilterOpen}
              toggleDataFilterOpen={toggleDataFilterOpen}
            />
          )}
      </div>

      {(props.scores.completed_assessments < limit ||
        (props.scores.total < limit && props.filtersArr.length > 0) ||
        !props.coData.analytics_open ||
        props.coData.analytics_open !== 'yes') && (
        <div id="health-report" className="results-content">
          <TextArea containerClass="clear half_square noreport" />
          <TextArea containerClass="clear half_square">
            <CircleGraph
              title="Platform"
              colour="red"
              value={props.scores.completed_assessments}
              subText={t('LA011')}
              large
              percent={engagement}
              modalText={t('LA003')}
              onOpenModal={props.onOpenModal}
            />

            <span className="health_assessment_closed">
              {props.scores.total < limit && props.filtersArr.length > 0 ? (
                <>
                  <h2>{t('LA004')}</h2>
                  <p>{t('LA005')}</p>
                </>
              ) : (
                <>
                  <h2>{t('LA006')}</h2>
                  {!props.disableFilters && (
                    <p>
                      {t('LA007')}{' '}
                      <Link to="/company-report/engagement-resources">{t('LA008')}</Link>.
                    </p>
                  )}
                </>
              )}

              {!props.disableFilters && (
                <>
                  <Link to="/company-report/engagement-resources">
                    <button className="green" type="button">
                      <FontAwesomeIcon icon={faArrowUp} className="" />
                      {t('LA009')}
                    </button>
                  </Link>
                  <button
                    className="black right"
                    type="button"
                    onClick={() => {
                      props.onOpenModal();
                    }}
                  >
                    {t('LA010')}
                  </button>
                </>
              )}
            </span>
          </TextArea>
        </div>
      )}
    </div>
  );
}
export default LiveAnalytics;
